export default __webpack_public_path__ + "static/BookHover-6cfef8e1d84ba68bf2af43fd525a2656.png";